import React, { useEffect } from 'react';
import { initGA, sendPageView } from './utils/analytics';
import { SERVICES, FAQS, CONTACT_INFO, SOCIAL_LINKS } from './constants/data';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Services from './components/Services';
import Features from './components/Features';
import Process from './components/Process';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function LandingPage() {
  useEffect(() => {
    initGA();
    sendPageView();
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="bg-white text-gray-900">
      <Header scrollToSection={scrollToSection} />

      <main>
        <Hero
          whatsappLink={CONTACT_INFO.whatsapp}
        />

        <Problem />

        <Services services={SERVICES} />

        <Features />

        <Process />

        <FAQ faqs={FAQS} />

        <ContactForm />

        <CTA
          whatsappLink={CONTACT_INFO.whatsapp}
        />
      </main>

      <Footer socialLinks={SOCIAL_LINKS} />
    </div>
  );
}